import React, { ReactNode } from 'react';

import { Tabs, TabsProps } from '@mantine/core';

import classes from './kiloTabs.module.css'; // We'll define custom CSS

type KiloButtonProps = TabsProps & {
  activeTab: string;
  setActiveTab: (value: string) => void;
  children: ReactNode;
};

const KiloTabs = ({ activeTab, setActiveTab, children, ...props }: KiloButtonProps): JSX.Element => {
  return (
    <Tabs
      value={activeTab}
      onTabChange={setActiveTab}
      // tabsList becomes list in v7
      classNames={{ tabsList: classes.list, tab: classes.tab }}
      {...props}
    >
      <Tabs.List>{children}</Tabs.List>
    </Tabs>
  );
};

export default KiloTabs;
